import { render } from "./Skills.vue?vue&type=template&id=248967a6"
import script from "./Skills.vue?vue&type=script&lang=js"
export * from "./Skills.vue?vue&type=script&lang=js"

import "./Skills.vue?vue&type=style&index=0&id=248967a6&lang=scss"
script.render = render

export default script